import Vue from "vue";
import App from "./App.vue";
import store from "./store";

import "./plugins/vue-drag-drop.js";
import vuetify from "./plugins/vuetify.js";

import "./assets/css/styles.scss";

Vue.config.productionTip = false;

new Vue({
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
